module.exports = __webpack_public_path__ + "img/button_diameter.9dab1308.png";